export const TEST_ID = 'activityCard';
